import React from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system';
import Modal from 'utils/packages/Modal';
import { WithdrawalTimesInfoModalContent } from './WithdrawalTimesInfoModalContent';
export const WithdrawalTimesInfoModal = {
    show: (withdrawalInfo) => {
        Modal.show(<WithdrawalTimesInfoModalContent withdrawalInfo={withdrawalInfo} hideModal={Modal.hide}/>, {
            title: 'Withdrawal times',
            containerStyle: styles.modal,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    footer: {
        paddingHorizontal: rem(16),
    },
});
